@if (enableAdCarousel()) {
    <div class="carousel-container" [class.plp]="isNarrowBanner()" [class.hmf-mt-s]="hasTopMargin()">
    <div class="carousel-slides">
        <div class="carousel-slide evergreen-carousel-slide"
            [class.active]="currentSlide() === 0"
            [class.pdp]="!isNarrowBanner()"
            [class.plp]="isNarrowBanner()"
            [attr.tabindex]="currentSlide() === 0 ? 0 : -1">
            @if (templateData()) {
                <shared-components-evergreen-template 
                    [templateData]="templateData()" 
                    [isNarrowTemplate]="isNarrowBanner()">
                </shared-components-evergreen-template>
            }
        </div>
        <div class="carousel-slide" [class.active]="currentSlide() === 1">
            <div
                [id]="data"
                class="google-ad-container hmf-mx-auto hmf-mb-0"
                >
            </div>
        </div>
    </div>
        <div class="carousel-controls" [class.active]="currentSlide() === 1 || shouldShowSponsoredLabel()">
            <div class="carousel-button-container-wrapper">
                <div class="carousel-button-container" [class.active]="currentSlide() === 0">
                    <homefield-icon class="carousel-button" height="8px" width="8px" name="sign-circle" fill="#E0DCD9" tabindex="0" (keyup)="currentSlide.set(0)" (click)="currentSlide.set(0)"></homefield-icon>
                </div>
                <div class="carousel-button-container" [class.active]="currentSlide() === 1">
                    <homefield-icon class="carousel-button" height="8px" width="8px" name="sign-circle" fill="#E0DCD9" tabindex="0" (keyup)="currentSlide.set(1)" (click)="currentSlide.set(1)"></homefield-icon>
                </div>
            </div>
            <div
                id="carouselSponsoredLabel"
                [class.active]="currentSlide() === 1"
                [class.plp]="isNarrowBanner()"
                [class.pdp]="!isNarrowBanner()"
                [ngClass]="{'dsg-store-sponsored-tag': isDsgStorePage}">
                <button
                    id="sponsoredButton"
                    class="sponsored-button hmf-display-flex"
                    (click)="loadSurvey()">
                    <p class="sponsored-text hmf-body-s">
                        Sponsored
                    </p>
                    <div class="icon-container">
                        <homefield-icon
                            *ngIf="enableTooltipSurvey()"
                            width="14px"
                            height="14px"
                            fill="var(--hmf-label-base-subtle)"
                            name="alert-info-outlined"/>
                    </div>
                </button>
            </div>
        </div>
</div>
} @else {
    <div
        [id]="data"
        class="google-ad-container hmf-mx-auto hmf-mb-0"
        [class.hmf-mt-s]="hasTopMargin()">
    </div>
    @if (shouldShowSponsoredLabel()) {
        <div
            class="hmf-display-flex hmf-align-items-center hmf-justify-content-end hmf-mb-s"
            id="sponsoredLabel"
            [class.pdp]="!isNarrowBanner()"
            [ngClass]="{'dsg-store-sponsored-tag': isDsgStorePage}">
            <button
                id="sponsoredButton"
                class="sponsored-button hmf-display-flex"
                (click)="loadSurvey()">
                <p class="sponsored-text hmf-body-s">
                    Sponsored
                </p>
                 <div class="icon-container">
                    <homefield-icon
                        *ngIf="enableTooltipSurvey()"
                        width="14px"
                        height="14px"
                        fill="var(--hmf-label-base-subtle)"
                        name="alert-info-outlined"/>
                </div>
            </button>
        </div>
    }
}
